import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export type SectionRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  today: Date;
  denseFormat?: boolean;
  registerNewTaskInput: (sectionId: ID, element: HTMLDivElement | null) => void;
  onAddTask: (sectionId: ID) => void;
};

export const SectionRenderDataContext = createContext<SectionRenderData | null>(
  null,
);

export const useSectionRenderData = (): SectionRenderData => {
  const data = useContext(SectionRenderDataContext);
  if (!data) {
    throw new Error(
      'useSectionRenderData must be used within a SectionGroupingTasksList',
    );
  }
  return data;
};
